import {CommandClause, CPCLCommand} from "@psdk/frame-father";
import {BasicCPCLArg} from "./basic";
import {CPageHeight} from "./pageheight";
import {CPageWidth} from "./pagewidth";

export class CPage extends BasicCPCLArg<CPage> {
  private readonly width: number;
  private readonly height: number;
  private readonly copies: number;

  constructor(options?: {

    width?: number,
    height?: number
    copies?: number
  }) {
    super();
    this.width = options?.width ?? 0;
    this.height = options?.height ?? 0;
    this.copies = options?.copies ?? 1;
  }

  clause(): CommandClause {
    super.prepend(new CPageHeight({height: this.height, copies: this.copies}));
    super.append(new CPageWidth({width: this.width}));
    return CPCLCommand.with(this.header())
      .clause();
  }

  header(): string {
    return '';
  }
}



